<template>
  <v-btn
    v-if="core.export"
    id="export_button"
    dark
    block
    large
    color="primaryButton"
    :disabled="!(core.tableItems.length > 0) || !core.enableIdentify"
    @click="core.export.show_export_modal"
    class="tour_map_step4"
  >
    <v-icon>mdi-content-save</v-icon>
    <!-- <span v-if="core.tableWidthSize != 'xs'">{{ $t("common.export") }}</span> -->
    <span>{{ $t("common.export") }}</span>
  </v-btn>
  <!-- hidden title <v-btn
        :title="$t('common.title_export')"
        large
        :color="core.tableItems.length > 0 ? 'primaryButton' : ''"
        :disabled="!(core.tableItems.length > 0)"
        @click="show_export_modal"
      >
        <v-icon>mdi-content-save</v-icon>
        <span>{{ $t("common.export") }}</span>
      </v-btn> -->
</template>

<script>
export default {
  props: ["core"],
};
</script>